import React from "react";
import { GlobalContext } from "../../../contexts/Global";
import tagToWord from "../../../utils/tagToWord";
import { render } from "storyblok-rich-text-react-renderer";
import Link from "../../../utils/link";
import { useStaticQuery, graphql } from "gatsby"

const ProjectScopeCopy = (props) => {

    const blok = props.blok


    const data = useStaticQuery(graphql`
    {
        filters: allStoryblokDatasourceEntry(
            filter: {parent: {}, data_source: {glob: "type-of-work-projects"}}
          ) {
            edges {
              node {
                id
                value
                name
                data_source
              }
            }
          }
        
      }
      
  `)

    const filters = data.filters.edges.map((filter) => {
        return filter.node.value
    })

    return (
        <section className="width py-8 lg:py-9 lg:text-lg ">

            <div className="lg:pl-20 grid lg:grid-cols-4 gap-8 lg:gap-0">

                {/* Left Side w Tag List */}

                <div className="space-y-4">

                    <h2 className="font-semibold">
                        Project Scope:
                    </h2>


                    <GlobalContext.Consumer>
                        {global => (
                            <ol className="pl-4">
                                {global.tagList.map(tag => {

                                    if (!filters.includes(tag)) {
                                        return null
                                    }

                                    return (
                                        <li key={`project-scope-${tag}`}>
                                            <Link to={`/work/?tag=${tag}`} className='hover-underline-animation'>{tagToWord(tag)}</Link>
                                        </li>
                                    )
                                })}
                            </ol>
                        )}
                    </GlobalContext.Consumer>

                    {blok.collaborators && blok.length > 0 && (
                        <>
                            <h2 className="font-semibold">
                                Made lovingly with our friends:
                            </h2>


                            <ol className="pl-4">
                                {blok.collaborators.map(collaborator => (
                                    <li key={`project-collab-${collaborator.title}`}>
                                        {
                                            collaborator.url?.cached_url != "" || collaborator.url?.cached_url == undefined ? (
                                                <Link to={collaborator.url.cached_url} className='hover-underline-animation'>
                                                    {collaborator.title}
                                                </Link>
                                            )
                                                :
                                                collaborator.title
                                        }
                                    </li>
                                ))}
                            </ol>

                        </>
                    )}



                </div>

                {/* Right Side w Copy */}

                <div className="lg:col-span-3 lg:pr-44">
                    {render(blok.copy)}
                </div>

            </div>


        </section>
    )
}

export default ProjectScopeCopy